import { render, staticRenderFns } from "./BundleViewer.vue?vue&type=template&id=55068804&scoped=true&"
import script from "./BundleViewer.vue?vue&type=script&lang=js&"
export * from "./BundleViewer.vue?vue&type=script&lang=js&"
import style0 from "./BundleViewer.vue?vue&type=style&index=0&id=55068804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55068804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55068804')) {
      api.createRecord('55068804', component.options)
    } else {
      api.reload('55068804', component.options)
    }
    module.hot.accept("./BundleViewer.vue?vue&type=template&id=55068804&scoped=true&", function () {
      api.rerender('55068804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/detail/BundleViewer.vue"
export default component.exports